import React, { useContext, useState } from "react";
import SummaryTable from "./SummaryTable";
import { ProductRepositoryContext } from "../context/ProductRepositoryState";
import { PRODUCT_REPOSITORY_TYPE } from "../context/ActionType";
import { Box } from "@mui/material";
import DialogEditForm from "./DialogEditForm";

const SummaryTableController = () => {
  const { state, dispatch, products, total } = useContext(
    ProductRepositoryContext
  );
  const [modelData, setModelData] = useState(null);
  const [visible, setVisible] = useState(false);

  const setPageSize = (newPageSize) => {
    dispatch({
      type: PRODUCT_REPOSITORY_TYPE.UPDATE_PAGE_SIZE,
      payload: newPageSize,
    });
  };

  const setPageNumber = (newPage) => {
    dispatch({
      type: PRODUCT_REPOSITORY_TYPE.UPDATE_PAGE_NUMBER,
      payload: newPage + 1,
    });
  };

  const handleOpenModal = (params) => {
    setModelData(params.row);
    setVisible(true);
  };

  const handleCloseModal = () => {
    setVisible(false);
    setModelData(null);
  };

  return (
    <Box>
      <SummaryTable
        data={products}
        totalRowCount={total}
        pageNumber={state.pageNumber - 1}
        setPageNumber={setPageNumber}
        pageSize={state.pageSize}
        setPageSize={setPageSize}
        handleButton={handleOpenModal}
      />
      <DialogEditForm
        visible={visible}
        data={modelData}
        handleClose={handleCloseModal}
      />
    </Box>
  );
};

export default SummaryTableController;
